import React from 'react';
import { formatCurrency } from '../utils/currencyFormatter';
import { FileTextIcon, ArrowLeftIcon } from 'lucide-react';
export function InvoiceDetails({
  invoice,
  onBack,
  locale = 'en-US'
}) {
  if (!invoice) return null;
  return <div data-id="element-562">
      <div className="mb-8 flex items-center justify-between" data-id="element-563">
        <div className="flex items-center" data-id="element-564">
          <button onClick={onBack} className="mr-4 p-2 text-gray-400 hover:text-gray-500" data-id="element-565">
            <ArrowLeftIcon className="h-5 w-5" data-id="element-566" />
          </button>
          <div data-id="element-567">
            <h2 className="text-2xl font-bold text-gray-900" data-id="element-568">
              Invoice {invoice.invoiceNumber}
            </h2>
            <p className="mt-1 text-sm text-gray-500" data-id="element-569">
              View invoice details and line items
            </p>
          </div>
        </div>
        <div className="flex space-x-3" data-id="element-570">
          <span className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${invoice.status === 'Approved' ? 'bg-green-100 text-green-800' : invoice.status === 'Pending Approval' ? 'bg-yellow-100 text-yellow-800' : invoice.status === 'Paid' ? 'bg-blue-100 text-blue-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-571">
            {invoice.status}
          </span>
        </div>
      </div>
      <div className="bg-white shadow overflow-hidden sm:rounded-lg" data-id="element-572">
        <div className="px-4 py-5 sm:px-6 border-b border-gray-200" data-id="element-573">
          <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-574">
            Invoice Information
          </h3>
        </div>
        <div className="px-4 py-5 sm:p-6" data-id="element-575">
          <dl className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2" data-id="element-576">
            <div className="sm:col-span-1" data-id="element-577">
              <dt className="text-sm font-medium text-gray-500" data-id="element-578">Vendor</dt>
              <dd className="mt-1 text-sm text-gray-900" data-id="element-579">{invoice.vendor}</dd>
            </div>
            <div className="sm:col-span-1" data-id="element-580">
              <dt className="text-sm font-medium text-gray-500" data-id="element-581">Vendor ID</dt>
              <dd className="mt-1 text-sm text-gray-900" data-id="element-582">{invoice.vendorID}</dd>
            </div>
            <div className="sm:col-span-1" data-id="element-583">
              <dt className="text-sm font-medium text-gray-500" data-id="element-584">
                Invoice Date
              </dt>
              <dd className="mt-1 text-sm text-gray-900" data-id="element-585">
                {new Date(invoice.invoiceDate).toLocaleDateString(locale)}
              </dd>
            </div>
            <div className="sm:col-span-1" data-id="element-586">
              <dt className="text-sm font-medium text-gray-500" data-id="element-587">Due Date</dt>
              <dd className="mt-1 text-sm text-gray-900" data-id="element-588">
                {new Date(invoice.dueDate).toLocaleDateString(locale)}
              </dd>
            </div>
            <div className="sm:col-span-1" data-id="element-589">
              <dt className="text-sm font-medium text-gray-500" data-id="element-590">Country</dt>
              <dd className="mt-1 text-sm text-gray-900" data-id="element-591">{invoice.country}</dd>
            </div>
            <div className="sm:col-span-1" data-id="element-592">
              <dt className="text-sm font-medium text-gray-500" data-id="element-593">Currency</dt>
              <dd className="mt-1 text-sm text-gray-900" data-id="element-594">{invoice.currency}</dd>
            </div>
            <div className="sm:col-span-1" data-id="element-595">
              <dt className="text-sm font-medium text-gray-500" data-id="element-596">
                PO Reference
              </dt>
              <dd className="mt-1 text-sm text-gray-900" data-id="element-597">
                {invoice.poReference || 'N/A'}
              </dd>
            </div>
            <div className="sm:col-span-1" data-id="element-598">
              <dt className="text-sm font-medium text-gray-500" data-id="element-599">
                Payment Terms
              </dt>
              <dd className="mt-1 text-sm text-gray-900" data-id="element-600">
                {invoice.paymentTerms}
              </dd>
            </div>
            <div className="sm:col-span-2" data-id="element-601">
              <dt className="text-sm font-medium text-gray-500" data-id="element-602">
                Total Amount
              </dt>
              <dd className="mt-1 text-sm text-gray-900" data-id="element-603">
                {formatCurrency(invoice.total, invoice.currency, locale)}
              </dd>
            </div>
          </dl>
        </div>
      </div>
      {/* Line Items */}
      {invoice.lineItems && invoice.lineItems.length > 0 && <div className="mt-8 bg-white shadow overflow-hidden sm:rounded-lg" data-id="element-604">
          <div className="px-4 py-5 sm:px-6 border-b border-gray-200" data-id="element-605">
            <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-606">
              Line Items
            </h3>
          </div>
          <div className="overflow-x-auto" data-id="element-607">
            <table className="min-w-full divide-y divide-gray-200" data-id="element-608">
              <thead className="bg-gray-50" data-id="element-609">
                <tr data-id="element-610">
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-611">
                    Description
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-612">
                    Quantity
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-613">
                    Unit Price
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-614">
                    Total
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200" data-id="element-615">
                {invoice.lineItems.map((item, index) => <tr key={index} data-id="element-616">
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-617">
                      {item.description}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-618">
                      {item.quantity}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-619">
                      {formatCurrency(item.unitPrice, invoice.currency, locale)}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-620">
                      {formatCurrency(item.quantity * item.unitPrice, invoice.currency, locale)}
                    </td>
                  </tr>)}
              </tbody>
              <tfoot className="bg-gray-50" data-id="element-621">
                <tr data-id="element-622">
                  <th scope="row" colSpan={3} className="px-6 py-3 text-left text-sm font-medium text-gray-900" data-id="element-623">
                    Total
                  </th>
                  <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-900" data-id="element-624">
                    {formatCurrency(invoice.total, invoice.currency, locale)}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>}
    </div>;
}